
import { Component, Vue } from 'vue-property-decorator';

import Form9ProcessHeader from "@/components/process/Form9/components/Form9ProcessHeader.vue";
import Form9CaseInformation from "@/components/process/Form9/components/Form9CaseInformation.vue";
import { form9StatusInfoType } from '@/types/Information/Form9';

@Component({
    components:{
        Form9ProcessHeader,
        Form9CaseInformation
    }
})
export default class StartForm9 extends Vue {

    stepsCompleted = {} as form9StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }  


}
